export default {
    entityKey: 'code-repositories',
    titles: {
        singular: 'Code Repository',
        plural: 'Code Repositories'
    }
}
